import {
	fetchPublicAboutStats,
	fetchStudioStats,
} from "@bodhistreams/api/src/statsApi";
import { useQuery } from "@tanstack/react-query";

export const statsQueryKeys = {
	all: ["stats"],
	publicAbout: () => [...statsQueryKeys.all, "public-about"],
	studio: () => [...statsQueryKeys.all, "studio"],
};

export const usePublicAboutStats = () => {
	return useQuery({
		queryKey: statsQueryKeys.publicAbout(),
		queryFn: fetchPublicAboutStats,
		staleTime: 5 * 60 * 1000,
		gcTime: 15 * 60 * 1000,
	});
};

/**
 * Hook to fetch aggregate studio statistics for the admin dashboard
 * @returns {Object} React Query result
 */
export const useStudioStats = () => {
	return useQuery({
		queryKey: statsQueryKeys.studio(),
		queryFn: fetchStudioStats,
		staleTime: 2 * 60 * 1000, // 2 minutes
		gcTime: 10 * 60 * 1000, // 10 minutes
	});
};
